
import { motion } from 'framer-motion';

const SolutionCards = () => {
  const solutions = [
    {
      icon: 'ri-checkbox-circle-line',
      gradient: 'from-orange-400 to-green-500',
      title: 'Kullanıcı Onaylı Envanter Güvenliği',
      description: '"Donanım kimde?" sorusuna son. Kullanıcılarınız kendilerine atanan cihazları kendi ekranlarında görür, tek tuşla doğrular. Hatalı atamaların önüne geçin, veritabanınızı güncel tutun.',
      features: [
        'Anlık bildirim',
        'Tek tık onay',
        'Otomatik güncelleme'
      ],
      color: 'text-green-600'
    },
    {
      icon: 'ri-file-text-line',
      gradient: 'from-blue-400 to-purple-500',
      title: 'Saniyeler İçinde Zimmet Formu',
      description: 'Kağıttan vazgeçemeyenler için akıllı çözüm. ManageEngine verilerini kullanarak tek tıkla firmanıza özel, logolu ve profesyonel zimmet çıktıları alın. Arşivleme sürenizi %90 azaltın.',
      features: [
        'Özel logo ekleme',
        'Otomatik veri çekme',
        'PDF/Excel export'
      ],
      color: 'text-purple-600'
    }
  ];

  return (
    <section id="solutions" className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-5xl font-bold text-[#1A2B4A] mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
            İki Güçlü Senaryo, Tek Platform
          </h2>
          <p className="text-xl text-gray-600">
            İhtiyacınıza göre seçin, istediğiniz zaman geçiş yapın
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8">
          {solutions.map((solution, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              whileHover={{ y: -8, boxShadow: '0 20px 40px rgba(255, 107, 53, 0.2)' }}
              className="bg-white rounded-3xl p-8 shadow-lg border border-gray-100 hover:border-[#FF6B35]/30 transition-all cursor-pointer"
            >
              <div className={`w-20 h-20 rounded-2xl bg-gradient-to-br ${solution.gradient} flex items-center justify-center mb-6 shadow-lg`}>
                <i className={`${solution.icon} text-4xl text-white`}></i>
              </div>

              <h3 className="text-3xl font-bold text-[#1A2B4A] mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                {solution.title}
              </h3>

              <p className="text-gray-600 leading-relaxed mb-6 text-base">
                {solution.description}
              </p>

              <div className="space-y-3">
                {solution.features.map((feature, idx) => (
                  <div key={idx} className="flex items-center space-x-3">
                    <i className={`ri-check-line text-xl ${solution.color}`}></i>
                    <span className="text-gray-700 font-medium">{feature}</span>
                  </div>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SolutionCards;
